export default "__VITE_ASSET__ee663723__"